var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.user_type!=_vm.$keys.WHOLESALER)?_c('div',[_c('warehouse-overview')],1):_c('div',[_c('wholesaler-overview')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }